import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'dynamicFontSize'
})
export class DynamicFontSizePipe implements PipeTransform {

  transform(value: string, minFontSize: number, maxFontSize: number, minChars: number, maxChars: number): string {
    if (!value) return `${minFontSize}px`;

    const length = value.length;
    let fontSize: number;

    if (length <= minChars) {
      fontSize = maxFontSize;
    } else if (length >= maxChars) {
      fontSize = minFontSize;
    } else {
      // Linear interpolation between minFontSize and maxFontSize
      const scale = (maxFontSize - minFontSize) / (minChars - maxChars);
      fontSize = maxFontSize + scale * (length - minChars);
    }

    return `${fontSize/10}rem`;
  }
}
